import script from "./MyBookmarkedProductsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBookmarkedProductsTab.vue?vue&type=script&setup=true&lang=js"

import "./MyBookmarkedProductsTab.vue?vue&type=style&index=0&id=a39bd9cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a39bd9cc"]])

export default __exports__